<template>
  <div v-if="company" class="row summary py-4 g-4">
    <div v-if="company.company_name_en" class="col-12">
      <MainInfo :company="company" />
    </div>
    <div v-else-if="company.fio && !company.name" class="col-12">
      <MainInfo :company="company" />
    </div>
    <template v-else>
      <div class="col-md-6 col-lg-5 col-12 first-block">
        <MainInfo class="summary-card" :company="company" />
        <FinancesInfo
          v-if="finances && (finances?.finances_years?.length || finances?.additional_finances)"
          class="summary-card"
          :finances="finances"
          :html="company?.html_checko"
          @change-tab="handleTabChange"
        />
        <LicensesInfo class="summary-card" :amount="company?.licenses?.length || 0" @change-tab="handleTabChange" />
        <BranchesInfo
          v-if="company?.division"
          class="summary-card"
          :amount="company?.division[0]?.filials?.length || 0"
          @change-tab="handleTabChange"
        />
      </div>
      <div class="col-md-6 col-lg-3 col-12 second-block">
        <ContactInfo class="summary-card" :contacts="company?.contacts" />
        <ConnectionsInfo class="summary-card" :connections="connections" @change-tab="handleTabChange" />
        <FoundersInfo
          class="summary-card"
          :founders="company?.founders ? company?.founders[0]?.PP : company?.founder_organizations"
          :company-name="company.name || company.fio"
          @change-tab="handleTabChange"
        />
        <CheckingsInfo class="summary-card" :inspections="inspections" @change-tab="handleTabChange" />
      </div>
      <div class="col-md-6 col-lg-4 col-12 third-block">
        <AnalyzeInfo v-if="company.html_checko" class="summary-card" :company="company" @change-tab="handleTabChange" />
        <ArbitrationInfo
          class="summary-card"
          :company-name="company.name || company.fio"
          :cases-amount="casesAmount"
          @change-tab="handleTabChange"
        />
        <PurchasesInfo class="summary-card" :contracts="contracts" />
        <FedresursInfo class="summary-card" :messages="fedresursMessages" @change-tab="handleTabChange" />
        <BankruptcyInfo class="summary-card" :messages="bankruptcyMessages" @change-tab="handleTabChange" />
      </div>
    </template>
  </div>
</template>

<script>
  import { defineComponent } from 'vue';
  import MainInfo from './cards/MainInfo.vue';
  import ContactInfo from './cards/ContactInfo.vue';
  import AnalyzeInfo from './cards/AnalyzeInfo.vue';
  import ConnectionsInfo from './cards/ConnectionsInfo.vue';
  import ArbitrationInfo from './cards/ArbitrationInfo.vue';
  import FoundersInfo from './cards/FoundersInfo.vue';
  import CheckingsInfo from './cards/CheckingsInfo.vue';
  import PurchasesInfo from './cards/PurchasesInfo.vue';
  import FinancesInfo from './cards/FinancesInfo.vue';
  import LicensesInfo from './cards/LicensesInfo.vue';
  import BranchesInfo from './cards/BranchesInfo.vue';
  import FedresursInfo from './cards/FedresursInfo.vue';
  import BankruptcyInfo from './cards/BankruptcyInfo.vue';
  import { useStore } from 'vuex';

  export default defineComponent({
    components: {
      MainInfo,
      ContactInfo,
      AnalyzeInfo,
      ConnectionsInfo,
      ArbitrationInfo,
      FoundersInfo,
      CheckingsInfo,
      PurchasesInfo,
      FinancesInfo,
      LicensesInfo,
      BranchesInfo,
      FedresursInfo,
      BankruptcyInfo,
    },
    emits: ['change-tab'],
    props: {
      company: Object,
      finances: Object,
      inspections: Array,
      enforcements: Array,
      contracts: Array,
      connections: {
        type: Array,
        default: () => [],
      },
      fedresursMessages: Array,
      bankruptcyMessages: Array,
      activeTab: String,
      casesAmount: Number,
    },
    setup(_, { emit }) {
      const store = useStore();
      const isLoggedIn = store.state.auth.status.loggedIn;

      const handleTabChange = (newTab) => {
        emit('change-tab', newTab);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      };

      return {
        handleTabChange,
        isLoading: store.getters.isLoading,
        error: store.getters.getError,
        isLoggedIn,
      };
    },
  });
</script>
